import ReactDOM from 'react-dom'
import { useEffect, useState} from "react"
import {CloseOutlined} from '@ant-design/icons'

export const useShadow = (components)=>{
  const [shadow,setShadow] = useState(false)
  useEffect (()=>{
    ReactDOM.render(shadow?<IntoBigImg components={components} shadow={shadow} setShadow={setShadow}/>:'',document.getElementById('modal'))
  },[shadow,components])

  return setShadow

}
function IntoBigImg(props){
  let {setShadow,components}= props
  return (
    <div className="bigimg-box">
      <div className="exit-bigph" ><CloseOutlined onClick={()=>{setShadow(false)}}/></div>
      <div className="bigimg-modal">
        {components}
      </div>
    </div>
  )
}